import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Auth0Provider } from '@auth0/auth0-react';
import { BrowserRouter } from 'react-router-dom'
import { AppProvider } from './AppProvider';
import AppVersionCheck from './AppVersionCheck';
import { PostHogProvider} from 'posthog-js/react'

const REACT_APP_PUBLIC_POSTHOG_KEY= 'phc_kTQMJe9yTkyGTYZAZ4rTVQWEcAendbJtGNU2GN5MbXk'
const REACT_APP_PUBLIC_POSTHOG_HOST= 'https://us.i.posthog.com'
const options = {
  api_host: REACT_APP_PUBLIC_POSTHOG_HOST,
}


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
      <Auth0Provider
          domain="dev-5h33aun.us.auth0.com"
          // domain="auth.facticity.ai"
          clientId="fvsQ9DT16eWAbmF6IL6ZApvkpdgjtf3L"
          authorizationParams={{
            redirect_uri: window.location.origin,
            audience: 'https://backend.facticity.ai',
            scope: 'openid profile email offline_access'
          }}
          useRefreshTokens={ true }
          cacheLocation="localstorage"
          
        >
          <PostHogProvider 
            apiKey={REACT_APP_PUBLIC_POSTHOG_KEY}
            options={options}
          >
            <AppProvider>
              <App>
                <AppVersionCheck />
                {/* Other routes/components */}
              </App>
            </AppProvider>
          </PostHogProvider>

        </Auth0Provider>
        {/* <Auth0Provider
          domain="auth.facticity.ai"
          clientId="fvsQ9DT16eWAbmF6IL6ZApvkpdgjtf3L"
          authorizationParams={{
            redirect_uri: window.location.origin,
          }}
          cacheLocation="localstorage"
        >
          <AppProvider>
            <App />
          </AppProvider>
        </Auth0Provider> */}

  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

